import { main_url } from "../../constants";

import { useMutation } from "react-query";
import axios from "axios";
import AuthContext from "../../context/AuthContext";
import { useContext } from "react";

export const usePutQuery = (url: string, token?: string) => {
  const ctxAuth = useContext(AuthContext);
  const {
    data,
    error,
    reset,
    status,
    mutate,
    mutateAsync,
    isError,
    isIdle,
    isLoading,
    isSuccess,
    isPaused,
  } = useMutation(
    async (collectedData: FormData) => {
      return axios.put(`${main_url}${url}`, collectedData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
    },
    {
      onError: (err: any) => {
        const error = err.response.data;
        //check if its a token validation error
        if (error?.code === "token_not_valid") {
          ctxAuth.logout();
        } else {
          return err.response.data;
        }
      },
    }
  );

  return {
    data,
    error,
    reset,
    status,
    mutate,
    mutateAsync,
    isError,
    isIdle,
    isLoading,
    isSuccess,
    isPaused,
  };
};
